import { useSelector } from 'react-redux';

import { get } from 'lodash';
import moment from 'moment';

import { selectCurrentMaster, selectCurrentUser } from '@lib/selectors';

const localTimeZoneIANA = Intl.DateTimeFormat().resolvedOptions().timeZone || moment.tz.guess();

export default function useCurrentTimezone() {
  const currentMaster = useSelector(selectCurrentMaster);
  const currentUser = useSelector(selectCurrentUser);
  const timezone =
    get(currentMaster, 'settings.timezone') || get(currentUser, 'settings.timezone') || localTimeZoneIANA;

  return timezone;
}
